<template>
  <div id="author-submit-manuscripts">
    <div class="ipub-h1 mar-b-10">{{firstPath == '/editorial-office/manuscripts/submit-manuscripts'?'Edit Submission':'New Submission'}}</div>
    <!-- 步骤条 -->
    <div class="mar-b-50 flex"
         style="align-items: center;justify-content: space-between;">
      <template v-for="item in stepList">
        <router-link v-if="(manuscript.step+1)>=(item.index)||item.index===1"
                     :to="`${firstPath}${item.href}${id?'?id='+id:''}`"
                     :key="item.href"
                     :class="[
          'author-submit-manuscripts-stepTitle-Item',
          path.includes(item.href) ? 'active' : (manuscript.step+1)>=(item.index)||item.index===1 ? '':'disabled'
        ]">
          <div class="line"></div>
          <div class="author-submit-manuscripts-stepTitle">
            <ipub-icon :type="item.icon"
                       class="author-submit-manuscripts-stepTitle-icon" />
          </div>
          <div class="author-name">{{ item.name }}</div>
        </router-link>
        <a class="disabled-icon author-submit-manuscripts-stepTitle-Item"
           :key="item.href"
           v-else>
          <div class="line"></div>
          <div class="author-submit-manuscripts-stepTitle">
            <ipub-icon :type="item.icon"
                       class="author-submit-manuscripts-stepTitle-icon" />
          </div>
          <div class="author-name">{{ item.name }}</div>
        </a>
      </template>
    </div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
